import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { DatePipe } from "@angular/common";
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { PrintColumnModel } from './print.model';
@Component({
	selector: 'modal-content',
	templateUrl: './print.preview.html'
})
export class PrintPreview implements OnInit {
	_printdata: any[] = [];
	data:any;
	col:any;
	@Output() printEvent = new EventEmitter();

	@Input() set printData(val: any[]) {
        this._printdata = val;
        this.col = this._printdata['columns'];
      //   this.data.columns = this._printdata['columns'];
        let printType = val['type'];
         let printdata = (Object.assign({}, {columns:val['columns']})).columns;
          this.data.columns = printdata;
        if(printType=="invoice"){
        	this.generateInvoicePrint();
        }else{
        	this.generatePrintContent();
        }
    }

    get printData(): any[] {
        return this._printdata;
    }

	constructor(public printModalRef: BsModalRef, public toasterService: ToasterService, public datePipe: DatePipe) {

	}

	ngOnInit() {
        //this.col = this.columns;
		 this.data = {
		 	columns:[],
		 }


		
	}

	columns: PrintColumnModel[] = [];
	printStr: string = "";
	colids: any[] = [];
	totrows: any[] = [];
	//data:any;
	 isLoading: boolean = false;
	
      setTableColumnsWidth(viewType = 'sptrans') {
        const b = document.querySelector('.' + viewType + ' .sp-cf');
        b['onscroll'] =
            function () {
                const h = document.querySelector('.' + viewType + ' .sp-ch'),
                    f = document.querySelector('.' + viewType + ' .sp-cf'),
                    b = document.querySelector('.' + viewType + ' .sp-cb');
                h.scrollLeft = f.scrollLeft;
                b.scrollLeft = f.scrollLeft;
            };
        let ht = document.querySelector('.' + viewType + ' #sp-header-tab');
        let width = ht['offsetWidth'] + 15;
        $('.' + viewType + ' .sp-body-div').css({ width: width + 'px' });
    }
	generatePrintContent(){
		//console.log(this._printdata);
		/*_.forEach(this._printdata, (item, key) => {
			//console.log(key, item);
			if(key.toString()=="title"){
				this.setHeader(item, 'center');
			}

			if(key.toString()=="subTitle"){
				this.setSubHeader(item, 'center');
			}

			if(key.toString()=="columns"){
				this.columns = item;
				this.setColumns(item);
			}

			if(key.toString()=="rows"){
				this.setRows(item);
			}
		});*/

		let title = this._printdata['title'],
			subTitle = this._printdata['subTitle'],
			columns  = this._printdata['columns'],
			rows     = this._printdata['rows'],
			printTime= this._printdata['printTime'];

		this.columns = columns;

		this.setHeader(title, 'center', printTime);

		if(subTitle && subTitle!=''){
			this.setSubHeader(subTitle, 'center');
		}
		
		this.setColumns(columns);
		this.setRows(rows);

		$('#printContent').html(this.printStr);
	}

	setHeader(title:string, align:string, printTime:any){
		let cls = 'hdr1';
		cls += align=='center'?' txtaligncenter':'';
		this.printStr += '<div class="'+cls+'">'+title;

		if(printTime){
			let todayDt = this.datePipe.transform(new Date(), 'dd/MM/yyyy hh:mm a');
			this.printStr += '<span class="printTime">Date:- '+todayDt+'</span>';
		}

		this.printStr += '</div><br>';
	}

	setSubHeader(content:any, align:string){
		if(typeof content ==="object"){
			this.printStr += '<table class="subHdrTable"><tr>';
			_.forEach(content, (str, key)=>{
				if(str!='')
					this.printStr += '<td width="5%" align="right">'+key+' : </td><td width="5%" align="left">'+str+'</td>';
			});
			this.printStr += '</tr><table>';
		}else{
			let contSplt = content.split(",");

			this.printStr += '<table class="subHdrTable"><tr>';
			_.forEach(contSplt, (obj, key)=>{
				this.printStr += '<td width="5%">'+obj+'</td>';
			});
			this.printStr += '</tr><table>';
		}
		
		/*let cls = 'hdr1';
		cls += align=='center'?' txtaligncenter':'';
		this.printStr += '<div class="'+cls+'">'+content+'</div>';*/
	}

	setColumns(columns: PrintColumnModel){
		this.printStr += '<table width="100%" border="1" cellspacing="0" cellpadding="0" class="txt12"><thead><tr>';

		_.forEach(columns, (item, key) => {
			let prop = item['prop'],
				name = item['name'],
				width= item['width'],
				align= item['align'],
				sum  = item['sum'],
				tot = item['tot'],
				isPrint = item['isPrint'];

			if(isPrint!=false){
				let cls = '';
				cls += align!=''?' rmp txtalign'+align:'';

				this.printStr += '<th class="tdr tdb lmp tblbdr3 '+cls+'">'+name+'</th>';

				if(sum){
					this.totrows[prop] = 0;
				}
				if(tot){
					this.totrows[prop] = 0;
				}

				this.colids.push(prop);
			}
		});

        this.printStr += '</tr></thead>';
	}

	setRows(rows: any){
		_.forEach(rows, (item, key) => {
			//let rowObj = _.pick(item, this.colids);
			//let item.sno = key; 
			item.sno = key+1;
			this.printStr += '<tr>';
			_.forEach(this.columns, (rowobj, ind) => {
				let prop = rowobj['prop'],
					name = rowobj['name'],
					width= rowobj['width'],
					align= rowobj['align'],
					cellClass= rowobj['cellClass'],
					type = rowobj['type'],
					sum  = rowobj['sum'],
					tot  = rowobj['tot'],
					isPrint = rowobj['isPrint'],
					value= item[prop]?item[prop]:'';
					if(cellClass == 'txtRight'){
						cellClass = 'text-right';
					}
						if(cellClass == 'txtCenter'){
						cellClass = 'text-left';
					}

				if(isPrint!=false){
					let cls = '';
					cls += align!=''?' rmp txtalign'+cellClass:'';

					if(value!='' && type=="number"){
						value = parseInt(value);
					}

					if(value!='' && type=="float"){
						let decimal = rowobj['decimal']!=undefined?rowobj['decimal']:2;
						value = parseFloat(value).toFixed(decimal);
					}

					if(sum && value!=''){
						let sumfld = rowobj['sumfld']!=undefined?rowobj['sumfld']:prop,
							sumval = item[sumfld]!=undefined?item[sumfld]:value;
						this.totrows[prop] += parseFloat(sumval);
					}
					if(tot && value!=''){
						let sumfld = rowobj['sumfld']!=undefined?rowobj['sumfld']:prop,
							sumval = item[sumfld]!=undefined?item[sumfld]:value;
						this.totrows[prop] += parseFloat(sumval);
					}

					this.printStr += '<td class="tdr tdb lmp '+cellClass+'" styel="text-align:right">'+value+'</td>';
				}

			});
			this.printStr += '</tr>';
		});
		//console.log(this.totrows);
		/*if(_.keys(this.totrows).length>0){
			this.printStr += '<tr>';
			let sumtitle = this._printdata['sumtitle'],
				colInd = 0;
			_.forEach(this.columns, (rowobj, ind) => {
				let prop = rowobj['prop'],
					align= rowobj['align'],
					type = rowobj['type'],
					isPrint = rowobj['isPrint'],
					value= this.totrows[prop]?this.totrows[prop]:'';
				if(isPrint!=false){
					let cls = '';
					cls += align!=''?' rmp txtalign'+align:'';

					if(value!='' && type=="float"){
						let decimal = rowobj['decimal']!=undefined?rowobj['decimal']:2;
						value = parseFloat(value).toFixed(decimal);
					}

					if(colInd==0 && value==''){
						value = sumtitle;
						colInd++;
					}

					this.printStr += '<td class="tdr tdb lmp txtBold '+cls+'">'+value+'</td>';
				}
			});
			this.printStr += '</tr>';
		}*/
        		this.printStr += '<tr>';

		_.forEach(this.columns, (rowobj1, ind) => {
			let prop = rowobj1['prop'],
					name = rowobj1['name'],
					width= rowobj1['width'],
					align= rowobj1['cellClass'],
					type = rowobj1['type'],
					sum  = rowobj1['summary'],
					tot  = rowobj1['summary'];
					if(align == 'txtRight'){
						align = 'text-right';
					}
					let cls = '';
					cls += align!=''?' rmp txtalign'+''+align:'';
					if(sum=='sum' || tot=='tot'){
					let row = rows;
					let val = 0;
					for(let i = 0;i<row.length;i++){
						let summary=[];
						let name1 = row[i][prop];
						//let val=name1;
						val+=name1;
						summary[name]=val;
					}
					this.printStr += '<td class="tdr tdb lmp '+align+'" style="text-align:right">'+'<b>'+val+'</b>'+'</td>';

				}else if(name=='SNO'){
					this.printStr += '<td class="tdr tdb lmp text-left">'+'<b>'+'TOTAL'+'</b>'+'</td>';
				}
				else{
                    this.printStr += '<td class="tdr tdb lmp '+cls+'">'+''+'</td>';
				}

		});
		}

	  viewAdjust(cols) {
        let that = this;
        that.isLoading = true;
        setTimeout(function () {
         //   that.setTableColumnsWidth('sptrans');
            
                 //this._printdata['columns'] = [];
                 // this._printdata['columns'] = columns;
            that.isLoading = false;
        }, 200);
        this.printStr='';
           this.onChangeSelect(cols);
    }
    onChangeSelect(columns){
            let title = this._printdata['title'],
			subTitle = this._printdata['subTitle'],
			//columns  = this._printdata['columns'],
			rows     = this._printdata['rows'],
			printTime= this._printdata['printTime'];

		this.columns = columns;

		this.setHeader(title, 'center', printTime);

		if(subTitle && subTitle!=''){
			this.setSubHeader(subTitle, 'center');
		}
		
		this.setColumns(columns);
		this.setRows(rows);

		$('#printContent').html(this.printStr);
    }

	generateInvoicePrint(){
		let invdata = this._printdata['rows'],
			gsttype = invdata['gsttype'],
			gstin	= invdata['gstin'],
			cellno 	= invdata['mobileno'],
			phoneno = ''+invdata['phoneno'],
			company = invdata['company_name'],
			address = invdata['address'],
			pincode = ''+invdata['pincode'],
			city 	= invdata['city'],
			state= invdata['state'],
			district= invdata['district'],
			party 	= invdata['party_name'],
			paddress = invdata['paddress'],
			ppincode = ''+invdata['ppincode'],
			pcity 	= invdata['pcity'],
			pdistrict = invdata['pdistrict'],
			pstate 	= invdata['pstate'],
			pgstin  = invdata['pgstin'],
			invdt	= invdata['invdt'],
			invno 	= invdata['invno'],
			roundoff= invdata['roundoff'];

			cellno  = cellno==""?"&nbsp;":cellno;
			phoneno = phoneno==""?"&nbsp;":phoneno.replace("4632", "04632 - ");
			pincode = pincode.replace("628", "628 ");

		var invname = "Tax Invoice";
		if(gsttype=="Composition"){
			invname = "Bill of Supply";
		}

		//this.printStr += '<div class="txtaligncenter txt10"><span class="txtBold">'+invname+'</span><span class="invtype txt9">(ORIGINAL FOR RECIPIENT)</span></div>';
		this.printStr += '<div class="txtaligncenter txt10"><span class="txtBold">'+invname+'</span></div>';
		this.printStr += '<table width="100%" border="0" cellspacing="0" cellpadding="0" class="txt9"><thead><tr>';
		this.printStr += '<td class="tdl lmp tblbdr3 txt9" colspan="2">GSTIN: <span class="txtBold">'+gstin+'<span></td><td class="tdr lmp tblbdr3 txt9 txtalignright" colspan="4">Cell: '+cellno+'<br>'+phoneno+'</td>';
		
		this.printStr += '<tr><td class="tdl tdr txt10 txtBold txtaligncenter" colspan="6">'+company+'</td></tr>';
		this.printStr += '<tr><td class="tdl tdr txt9 txtaligncenter" colspan="6">'+address+'</td></tr>';
		this.printStr += '<tr><td class="tdl tdr txt9 tdb txtaligncenter" colspan="6">'+city+'-'+pincode+', '+district+', '+state+'</td></tr>';

		var partyAddress = paddress+'<br>'+pcity+'-'+ppincode;
			partyAddress += '</span><br>'+pdistrict+', '+pstate;
			partyAddress += '<br>GSTIN: <span class="txtBold">'+pgstin+'</span>';

		this.printStr += '<tr class="txt9">'
						  +'<td class="tdl tdb lmp partyaddr" colspan="3" rowspan="2">Buyer <br><span class="txtBold">'+party+'</span><br>'+partyAddress+'</td>'
						  +'<td class="tdl tdb tdr lmp" colspan="3"><span class="txtBold">INVOICE NO: </span>'+invno+'</td>'
						  +'</tr>';

		this.printStr += '<tr class="txt9">'
						 +'<td class="tdl tdb tdr lmp" colspan="3"><span class="txtBold">DATE: </span>'+invdt+'</td>'
						  +'</tr>';

		var invdet = JSON.parse(invdata.invdet);
		var hdr_bundle = 'Bundle', hdr_qty = 'Qty';
		if(invdet[0]['uom']=='Kgs'){
			hdr_bundle = 'Bag';
			hdr_qty = 'Kgs';
		}

		this.printStr += '<tr class="txt9 txtBold">'
						 +'<td class="tdl tdr tdb txtaligncenter tdhg30" width="10%">Rate</td>'
						 +'<td class="tdr tdb lmp txtaligncenter" width="35%">Particulars</td>'
						 +'<td class="tdr tdb lmp txtaligncenter" width="10%">HSN Code</td>'
						 +'<td class="tdr tdb txtaligncenter" width="10%">'+hdr_bundle+'</td>'
						 +'<td class="tdr tdb txtaligncenter" width="10%">'+hdr_qty+'</td>'
						 +'<td class="tdr tdb txtaligncenter" width="15%">Amount</td>'
						 +'<tr>';

		var rowCnt = 8;
		if(gsttype=="Composition"){
			rowCnt = 9;
		}
		/* if(pstate.toLowerCase()!="tamilnadu"){
			rowCnt = 10;
		} */

		var totGrossAmt = 0, totBun = 0, totQty = 0;
		
		for(var i=0; i<rowCnt; i++){
			var item = invdet[i],
				rate = '&nbsp;',
				name = '&nbsp;',
				hsn  = '&nbsp;',
				bund = '&nbsp;',
				qty  = '&nbsp;',
				amount = '&nbsp;';

			if(item){
				rate = item['rate'];
				name = item['name'];
				hsn  = item['hsncode'];
				bund = item['bundle']>0?item['bundle']:'&nbsp;';
				qty  = item['qty'];
				amount = item['grant_total'];
				
				totGrossAmt += parseFloat(amount);

				totBun += parseInt(bund);
				totQty += parseFloat(qty);

				rate = parseFloat(rate).toFixed(2);
				amount = parseFloat(amount).toFixed(2);
			}

			this.printStr += '<tr class="txt9">'
						 +'<td class="tdl txtaligncenter tdhg30" width="10%">'+rate+'</td>'
						 +'<td class="tdl lmp" width="35%">'+name+'</td>'
						 +'<td class="tdl lmp" width="10%">'+hsn+'</td>'
						 +'<td class="tdl txtaligncenter" width="10%">'+bund+'</td>'
						 +'<td class="tdl txtaligncenter" width="10%">'+qty+'</td>'
						 +'<td class="tdl tdr txtalignright" width="15%">'+amount+'</td>'
						 +'<tr>';
		}

		var sgstper = '&nbsp;',
			cgstper = '&nbsp;',
			igstper = '&nbsp;',
			sgstamt = '&nbsp;',
			cgstamt = '&nbsp;',
			igstamt = '&nbsp;';

		if(gsttype=="Regular"){
			igstper = invdata['igstper'];
			if(invdata['igstper']>0){
				igstamt = invdata['igstamt'];
				igstamt = parseFloat(igstamt).toFixed(2);
			}else{
				sgstper = invdata['cgstper'];
				cgstper = invdata['sgstper'];
				sgstamt = invdata['sgstamt'];
				cgstamt = invdata['cgstamt'];
				sgstamt = parseFloat(sgstamt).toFixed(2);
				cgstamt = parseFloat(cgstamt).toFixed(2);
			}
		}

		var amtwords   = this.convertNumberToWords(invdata['grant_total']);
		var grantTotal = parseFloat(invdata['grant_total']).toFixed(2);

		var totBunStr = totBun>0?totBun:"&nbsp;",
			totQtyStr = totQty>0?totQty:"&nbsp;";

		if(gsttype=="Regular"){
			this.printStr += '<tr class="txt9">'
							+'<td class="tdl txtaligncenter" width="10%">&nbsp;</td>'
							+'<td class="tdl txtalignright txtBold tdhg30" width="35%">&nbsp;</td>'
							+'<td class="tdl txtaligncenter" width="10%">&nbsp;</td>'
							+'<td class="tdl txtaligncenter" width="10%">&nbsp;</td>'
							+'<td class="tdl txtaligncenter" width="10%">&nbsp;</td>'
							+'<td class="tdl tdt tdr txtalignright" width="15%">'+totGrossAmt.toFixed(2)+'</td>'
							+'<tr>';
		}

		if(invdata['sgstper']>0 && pstate.toLowerCase()=="tamilnadu"){
			this.printStr += '<tr class="txt9">'
							+'<td class="tdl txtaligncenter" width="10%">&nbsp;</td>'
							+'<td class="tdl txtalignright txtBold tdhg30" width="35%">SGST '+sgstper+' %</td>'
							+'<td class="tdl txtaligncenter" width="10%">&nbsp;</td>'
							+'<td class="tdl txtaligncenter" width="10%">&nbsp;</td>'
							+'<td class="tdl txtaligncenter" width="10%">&nbsp;</td>'
							+'<td class="tdl tdr txtalignright" width="15%">'+sgstamt+'</td>'
							+'<tr>';
			this.printStr += '<tr class="txt9">'
							+'<td class="tdl txtaligncenter" width="10%">&nbsp;</td>'
							+'<td class="tdl txtalignright txtBold tdhg30" width="35%">CGST '+cgstper+' %</td>'
							+'<td class="tdl txtaligncenter" width="10%">&nbsp;</td>'
							+'<td class="tdl txtaligncenter" width="10%">&nbsp;</td>'
							+'<td class="tdl txtaligncenter" width="10%">&nbsp;</td>'
							+'<td class="tdl tdr txtalignright" width="15%">'+sgstamt+'</td>'
							+'<tr>';
		}
		if(invdata['igstper']>0){
			this.printStr += '<tr class="txt9">'
							+'<td class="tdl txtaligncenter" width="10%">&nbsp;</td>'
							+'<td class="tdl txtalignright txtBold tdhg30" width="35%">IGST '+igstper+' %</td>'
							+'<td class="tdl txtaligncenter" width="10%">&nbsp;</td>'
							+'<td class="tdl txtaligncenter" width="10%">&nbsp;</td>'
							+'<td class="tdl txtaligncenter" width="10%">&nbsp;</td>'
							+'<td class="tdl tdr txtalignright" width="15%">'+igstamt+'</td>'
							+'<tr>';
		}
		
		var rndStr = roundoff.toFixed(2);
		if(rndStr!='0.00'){
			this.printStr += '<tr class="txt9">'
							+'<td class="tdl txtaligncenter" width="10%">&nbsp;</td>'
							+'<td class="tdl txtalignright txtBold tdhg30" width="35%">RoundOff</td>'
							+'<td class="tdl txtaligncenter" width="10%">&nbsp;</td>'
							+'<td class="tdl tdb txtaligncenter" width="10%">&nbsp;</td>'
							+'<td class="tdl tdb txtaligncenter" width="10%">&nbsp;</td>'
							+'<td class="tdl tdb tdr txtalignright" width="15%">'+rndStr+'</td>'
							+'<tr>';
		}

		this.printStr += '<tr class="txt9">'
						 +'<td class="tdl tdb txtaligncenter" width="10%">&nbsp;</td>'
						 +'<td class="tdl tdb txtalignright txtBold tdhg30" width="35%">TOTAL</td>'
						 +'<td class="tdl tdb txtaligncenter" width="10%">&nbsp;</td>'
						 +'<td class="tdl tdb tdt txtaligncenter" width="10%">'+totBunStr+'</td>'
						 +'<td class="tdl tdb tdt txtaligncenter" width="10%">'+totQtyStr+'</td>'
						 +'<td class="tdl tdb tdr tdt txtalignright" width="15%">'+grantTotal+'</td>'
						 +'<tr>';

		this.printStr += '<tr class="txt9">'
						 +'<td class="tdl tdr lmp txtBold" colspan="6">Total Amount in words</td>'
						 +'<tr>';
		this.printStr += '<tr class="txt9">'
						 +'<td class="tdl tdb lmp tdr" colspan="6">'+amtwords+' Only</td>'
						 +'<tr>';

		if(gsttype=="Composition"){
			this.printStr += '<tr class="txt9">'
							+'<td class="tdl tdr tdb txtaligncenter" colspan="6">Declaration: Composition Taxable Person<br>Not Eligible to Collect Tax on Supplies</td>'
							+'<tr>';
		}

		var bankdet = invdata['bankname']+', '+invdata['bankbranch']+'<br>A/c No : '+invdata['bankacno']+'<br>IFSC CODE: '+invdata['bankifsc'];

		this.printStr += '<tr class="txt9">'
						 +'<td class="tdl tdb tdr lmp" colspan="2"><span class="txtBold">Bank A/c Details</span><br>'+bankdet+'</td>'
						 +'<td class="tdb tdr txtalignright vatop" colspan="4">For <span class="txtBold">'+company+'</span></td>'
						 +'<tr>';


		this.printStr += '</tr></thead></table>';

		var orinal = this.printStr,
			transport = orinal.replace("ORIGINAL FOR RECIPIENT", "DUPLICATE FOR TRANSPORTER"),
			supplier = orinal.replace("ORIGINAL FOR RECIPIENT", "TRIPLICATE FOR SUPPLIER");

		var extraBr = "";
		if(pstate.toLowerCase()!="tamilnadu"){
			extraBr = "<br>";
		}

		//$('#printContent').html(orinal+ '<br>' +transport+ '<br>' +extraBr+supplier);
		$('#printContent').html(orinal);
	}

	convertNumberToWords(amount) {
	    var words = new Array();
	    words[0] = '';
	    words[1] = 'One';
	    words[2] = 'Two';
	    words[3] = 'Three';
	    words[4] = 'Four';
	    words[5] = 'Five';
	    words[6] = 'Six';
	    words[7] = 'Seven';
	    words[8] = 'Eight';
	    words[9] = 'Nine';
	    words[10] = 'Ten';
	    words[11] = 'Eleven';
	    words[12] = 'Twelve';
	    words[13] = 'Thirteen';
	    words[14] = 'Fourteen';
	    words[15] = 'Fifteen';
	    words[16] = 'Sixteen';
	    words[17] = 'Seventeen';
	    words[18] = 'Eighteen';
	    words[19] = 'Nineteen';
	    words[20] = 'Twenty';
	    words[30] = 'Thirty';
	    words[40] = 'Forty';
	    words[50] = 'Fifty';
	    words[60] = 'Sixty';
	    words[70] = 'Seventy';
	    words[80] = 'Eighty';
	    words[90] = 'Ninety';
	    amount = amount.toString();
	    var atemp = amount.split(".");
	    var number = atemp[0].split(",").join("");
	    var n_length = number.length;
	    var words_string = "";
	    if (n_length <= 9) {
	        var n_array: any = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
	        var received_n_array = new Array();
	        for (var i = 0; i < n_length; i++) {
	            received_n_array[i] = number.substr(i, 1);
	        }
	        for (var i = 9 - n_length, j = 0; i < 9; i++, j++) {
	            n_array[i] = received_n_array[j];
	        }
	        for (var i = 0, j = 1; i < 9; i++, j++) {
	            if (i == 0 || i == 2 || i == 4 || i == 7) {
	                if (n_array[i] == 1) {
	                    n_array[j] = 10 + parseInt(n_array[j]);
	                    n_array[i] = 0;
	                }
	            }
	        }
	        var value: any = "";
	        for (var i = 0; i < 9; i++) {
	            if (i == 0 || i == 2 || i == 4 || i == 7) {
	                value = n_array[i] * 10;
	            } else {
	                value = n_array[i];
	            }
	            if (value != 0) {
	                words_string += words[value] + " ";
	            }
	            if ((i == 1 && value != 0) || (i == 0 && value != 0 && n_array[i + 1] == 0)) {
	                words_string += "Crores ";
	            }
	            if ((i == 3 && value != 0) || (i == 2 && value != 0 && n_array[i + 1] == 0)) {
	                words_string += "Lakhs ";
	            }
	            if ((i == 5 && value != 0) || (i == 4 && value != 0 && n_array[i + 1] == 0)) {
	                words_string += "Thousand ";
	            }
	            if (i == 6 && value != 0 && (n_array[i + 1] != 0 && n_array[i + 2] != 0)) {
	                words_string += "Hundred and ";
	            } else if (i == 6 && value != 0) {
	                words_string += "Hundred ";
	            }
	        }
	        words_string = words_string.split("  ").join(" ");
	    }
	    return words_string;
	}

	onPrint(){
		this.printEvent.emit();
	}
}


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/shared/print/print.preview.ts